<template>
  <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Productdetails" @hidden="$emit('close')">
      <div class="block block-bordered">
        <div class="block-header block-header-default" style="display: block;">
          <h6>Voer onderstaande gegevens in om het product in te boeken of sluit dit scherm</h6>
        </div>
          <div class="block-content">
            <form  onsubmit="return false">
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="Barcode">Barcode:</label>
                        <input v-model="barcode" type="text" class="form-control form-control-lg" id="Barcode">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="Location">Locatie:</label>
                        <input v-model="productLocation" type="text" class="form-control form-control-lg" id="Location" placeholder="A.01.01.01.01">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="ProductTitle">ProductTitel:</label>
                        <input v-model="productTitle" type="text" class="form-control form-control-lg" id="ProductTitle" placeholder="Washandje rood">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="Quantity">Aantal:</label>
                        <input v-model="productQuantity" type="number" class="form-control form-control-lg" id="Quantity" placeholder="6">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="Brand">Bestaande Merk:</label>
                        <multiselect v-model="productBrand" :options="brands" placeholder="Selecteer een leverancier" selected-label="✔" select-label="" deselect-label="✔" allow-input/>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="newBrand">Nieuwe merk:</label>
                        <input v-model="newBrand" type="text" class="form-control form-control-lg" id="newBrand" placeholder="Coca cola">
                    </div>
                </div>
                <button @click="createProduct" type="submit" class="btn btn-primary btn-lg">Opslaan</button>
            </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import http from '../utils/http'
export default {
  components: {},
  props: {
    barcode: String
  },
  data () {
    return {
      brands: [],

      productBrand: null,
      productTitle: null,
      productLocation: null,
      productQuantity: null,
      newBrand: null
    }
  },
  methods: {
    loadBrands () {
      http.get('brands')
      .then((result) => {
        this.brands = result.data.data
      })
    },
    createProduct () {
      let validData = true
      if (this.productBrand === null) {
        if (this.newBrand === null) {
          validData = false
        } else {
          this.productBrand = this.newBrand
        }
      }
      if (this.productTitle === null) {
        validData = false
      }
      if (this.productQuantity === null) {
        validData = false
      }

      if (validData) {
        const data = {
          brand: this.productBrand,
          gtin: this.barcode,
          stock_quantity: this.productQuantity,
          location: this.productLocation,
          name: this.productTitle,
          unknown: true,
          sku: this.barcode
        }

        this.$http.post(`/product`, data)
        .then((response) => {
          const product = response.data.data
          this.$swal('Hoera 😊', `Het product is succesvol aangemaakt.`, 'success')
          this.$emit('unkownProductCreated', { product })
          this.$refs.modal.hide()
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van het product. Probeer het opnieuw.`, 'error')
        })
      } else {
        this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van het product. Probeer het opnieuw.`, 'error')
      }
    }
  },
  created () {
    this.loadBrands()
  }
}
</script>




// WEBPACK FOOTER //
// UnkownProductModal.vue?c66ed91e